var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManualPreparePaymentCompleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-7350025 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 61.875C17.0775 61.875 4.125 48.9225 4.125 33C4.125 17.0775 17.0775 4.125 33 4.125C48.9225 4.125 61.875 17.0775 61.875 33C61.875 48.9225 48.9225 61.875 33 61.875ZM33 8.25C19.3457 8.25 8.25 19.3457 8.25 33C8.25 46.6543 19.3457 57.75 33 57.75C46.6543 57.75 57.75 46.6543 57.75 33C57.75 19.3457 46.6543 8.25 33 8.25Z",
    fill: "#14AA40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 26C31 24.8954 31.8954 24 33 24C34.1046 24 35 24.8954 35 26V48C35 49.1046 34.1046 50 33 50C31.8954 50 31 49.1046 31 48V26Z",
    fill: "#14AA40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 18C30 16.3431 31.3431 15 33 15C34.6569 15 36 16.3431 36 18C36 19.6569 34.6569 21 33 21C31.3431 21 30 19.6569 30 18Z",
    fill: "#14AA40"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualPreparePaymentCompleteIcon);
export default __webpack_public_path__ + "static/media/ManualPreparePaymentCompleteIcon.7b5b4016483d3a031f0c200cd74380e9.svg";
export { ForwardRef as ReactComponent };